
const newModel = () => {
    return {
        loaiTuyenduongQuetRacId: null,
        ten: null,
        tanSuat: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        loaiTuyenduongQuetRacId: null,
        ten: null,
        tanSuat: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        loaiTuyenduongQuetRacId: item.loaiTuyenduongQuetRacId,
        ten: item.ten,
        tanSuat: item.tanSuat,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        loaiTuyenduongQuetRacId: item.loaiTuyenduongQuetRacId,
        ten: item.ten,
        tanSuat: item.tanSuat,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        loaiTuyenduongQuetRacId: null,
        ten: null,
        tanSuat: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        loaiTuyenduongQuetRacId: item.loaiTuyenduongQuetRacId,
        ten: item.ten,
        tanSuat: item.tanSuat,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        loaiTuyenduongQuetRacId: null,
        ten: null,
        tanSuat: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const loaiTuyenduongQuetRacModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


